module.exports = __webpack_public_path__ + "static/media/1.203f0a38.png";